import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Deflate } from 'pako';
import logger from '../utils/logger';
var log = logger.createLogger('compressFile');
export var STATUS_COMPRESSING = 'compressing';
export var STATUS_COMPRESSED = 'compressed';
export var STATUS_UPLOADING = 'uploading';
export var STATUS_DONE = 'done';
export var STATUS_ERROR = 'error';
export var DEFLATE_SETTINGS = {
  'level': 2,
  'gzip': true
};
export var CHUNK_BYTE_LENGTH = 10 * 16 * 1024;
export function fileLoop(
//app
deflator, globalByteOffset, fileAsArrayBuffer, setFiles, file, fileIdx) {
  var cb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (err, byteOffset) {};
  var progressCb = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {};
  var delayedStep = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : setTimeout;
  var chunkByteLength = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : CHUNK_BYTE_LENGTH;
  //log.debug({deflator, globalByteOffset, fileAsArrayBuffer: !!fileAsArrayBuffer, setFiles: !!setFiles, cb: !!cb, fileIdx}, '@fileLoop');

  var fileAsArray = new Uint8Array(fileAsArrayBuffer);
  var numChunks = Math.ceil(fileAsArray.byteLength / chunkByteLength);
  var numPreChunks = Math.max(0, numChunks - 1);
  var byteOffset = 0;
  var step = function step(chunkIdx) {
    try {
      log.debug('fileLoop::step:: %s / %s', chunkIdx, numPreChunks);
      progressCb({
        chunkIdx: chunkIdx,
        numPreChunks: numPreChunks
      });
      if (chunkIdx < numPreChunks) {
        log.debug('full chunk %s / %s', chunkIdx, numPreChunks);
        deflator.push(new Uint8Array(fileAsArrayBuffer, byteOffset, chunkByteLength), false);
        byteOffset += chunkByteLength;
        setFiles(function (latestFiles) {
          var out = latestFiles.slice();
          out[fileIdx] = _objectSpread(_objectSpread({}, out[fileIdx]), {}, {
            compressedBytes: globalByteOffset + byteOffset,
            status: STATUS_COMPRESSING
          });
          log.debug('Updated fileIdx %s -> %s', fileIdx, out[fileIdx]);
          return out;
        });
        if (deflator.err) {
          return cb(deflator.msg || 'Deflate error');
        }
        return delayedStep(function () {
          return step(chunkIdx + 1);
        }, 0);
      } else {
        log.debug({
          globalByteOffset: globalByteOffset + byteOffset,
          fileSize: file.size
        }, 'last chunk: %s', globalByteOffset + byteOffset + chunkByteLength >= file.size);
        deflator.push(new Uint8Array(fileAsArrayBuffer, byteOffset), globalByteOffset + byteOffset + chunkByteLength >= file.size);
        var lastChunkBytes = fileAsArrayBuffer.byteLength - byteOffset; //TODO is this right? - globalByteOffset ?
        log.debug('last chunk size: %s B', lastChunkBytes);
        byteOffset += lastChunkBytes;
        if (deflator.err) {
          var errorMsg = deflator.msg || 'Deflate error';
          log.error({
            err: deflator.err,
            errorMsg: errorMsg
          }, 'finished with err');
          setFiles(function (latestFiles) {
            var out = latestFiles.slice();
            out[fileIdx] = _objectSpread(_objectSpread({}, out[fileIdx]), {}, {
              error: errorMsg,
              status: STATUS_ERROR
            });
            log.debug('Updated fileIdx %s -> %s', fileIdx, out[fileIdx]);
            return out;
          });
          return cb(errorMsg, globalByteOffset + byteOffset);
        }
        log.debug('deflator ready');
        setFiles(function (latestFiles) {
          var out = latestFiles.slice();
          out[fileIdx] = _objectSpread(_objectSpread({}, out[fileIdx]), {}, {
            compressedBytes: globalByteOffset + byteOffset,
            sizeCompressedBytes: deflator.result.byteLength,
            status: STATUS_COMPRESSING
          });
          log.debug('Updated fileIdx: %s -> %s', fileIdx, out[fileIdx]);
          return out;
        });
        return cb(null, globalByteOffset + byteOffset);
      }
    } catch (e) {
      cb(e || 'Error in fileLoop::step()');
    }
  };
  step(0);
}

//TODO refactor for input args relative to one file
export function compressFile(setFiles, numPreAcceptedFiles, file, acceptedFileIndex) {
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var progressCb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
  var delayedStep = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : setTimeout;
  var compressLoop = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : fileLoop;
  log.debug('@compressFile:: %s (%s B)', file.name, file.size);
  var reader = null;
  try {
    reader = new FileReader();
  } catch (e) {
    //SECURITY: Use shared JSDOM context so FileReader callbacks route inside/outside properly,
    //  such as in testing. JSDOM is stubbed out via aliases.js for browser builds.
    reader = new global.jsdom.window.FileReader();
  }
  var deflator = new Deflate(DEFLATE_SETTINGS);

  //Unclear if this is auto-chunked or not
  var globalByteOffset = 0;
  reader.onload = function (e) {
    try {
      log.debug('compressFile.reader::onload %s %s', file.name, acceptedFileIndex);
      var fileAsArrayBuffer = e.target.result;
      var fileIdx = numPreAcceptedFiles + acceptedFileIndex;
      compressLoop(deflator, globalByteOffset, fileAsArrayBuffer, setFiles, file, fileIdx, function (err, updatedGlobalByteOffset) {
        try {
          log.debug('compressFile->fileLoop->cb');
          if (err) {
            //FIXME inline?
            log.error({
              err: err
            }, 'bad deflate');
            return cb(err);
          }
          globalByteOffset = updatedGlobalByteOffset;
          log.debug('reader.onload %s chunk %s / %s / %s B => ? :: %s', file.name, fileAsArrayBuffer.byteLength, globalByteOffset, file.size, typeof deflator.result);
          if (globalByteOffset >= file.size) {
            //log.debug({result: deflator.result}, 'fileLoop full result');
            /*
                const compressedFile = defaultor.result.compressedFileArray.buffer;
                const dataToUpload = new Blob([compressedFile], {type: file.type});
                const fileToUpload = new Blob([dataToUpload], {type: file.type});
                data.append('file', fileToUpload, file.name);
                this.upload(data);
            */
            return cb(null, {
              bytes: updatedGlobalByteOffset,
              deflator: deflator,
              data: deflator.result
            });
          } else {
            log.debug({
              globalByteOffset: globalByteOffset,
              fileSize: file.size
            }, 'fileLoop done, but not full file..');
            return cb('Internal error: finished chunks but not full file');
          }
        } catch (e) {
          cb(e || 'Exception in compressFile upon handling compressLoop cb call');
        }
      }, progressCb, delayedStep);
    } catch (e) {
      cb(e || 'Exception in compressFile onLoad');
    }
  };

  //Without these the file gets stuck in STATUS_COMPRESSING forever if the read
  //fails (file moved/deleted after drop, I/O or permission error) since onload
  //never fires and cb is never called.
  reader.onerror = function () {
    var err = reader.error && reader.error.message || 'FileReader error';
    log.error({
      err: err,
      name: file.name
    }, 'compressFile.reader::onerror');
    cb(err);
  };
  reader.onabort = function () {
    log.error({
      name: file.name
    }, 'compressFile.reader::onabort');
    cb('File read aborted');
  };

  //TODO chunked read? tail-call loop over file.slice()'s (x MB)..
  reader.readAsArrayBuffer(file);
}